import React, { Fragment, useContext } from "react";
import ProductCategoryDropdown from "./ProductCategoryDropdown";
import { HomeContext } from "./index";
import useRevealOnScroll from "../../../hooks/useRevealOnScroll";

const ProductCategory = (props) => {
  const { data, dispatch } = useContext(HomeContext);

  const { ref, revealed } = useRevealOnScroll(0.12);

  return (
    <Fragment>
      <div
        ref={ref}
        className={`transition-all duration-700 transform ${
          revealed ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
        }`}
      >
        {/* Container principal avec design moderne et coloré */}
        <div className="bg-blue-100 from-blue-500 via-white to-yellow-50 rounded-2xl shadow-lg border-2 border-blue-100 overflow-hidden">
          {/* Header avec titre et actions */}
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 p-4 md:p-6 bg-gradient-to-r from-blue-100 via-blue-50 to-yellow-100 border-b-2 border-blue-200">
            {/* Titre section */}
            <div>
              <h2 className="text-xl md:text-2xl font-bold bg-gradient-to-r from-blue-800 to-blue-600 bg-clip-text text-yellow-500 text-transparent">
                Explorez notre collection
              </h2>
              <p className="text-xs md:text-sm text-blue-700 mt-0.5 font-medium">
                Trouvez le parfum parfait pour vous
              </p>
            </div>

            {/* Actions: Catégories et Recherche */}
            <div className="flex flex-wrap items-center gap-2">
              <button
                onClick={(e) =>
                  dispatch({
                    type: "categoryListDropdown",
                    payload: !data.categoryListDropdown,
                  })
                }
                className={`flex items-center gap-2 px-4 py-2.5 rounded-xl font-semibold text-sm transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-0.5 ${
                  data.categoryListDropdown
                    ? "bg-yellow-500 text-white shadow-yellow-300"
                    : "bg-white text-gray-700 hover:bg-yellow-100 border border-yellow-200"
                }`}
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
                <span>Catégories</span>
                <svg
                  className={`w-4 h-4 transition-transform duration-300 ${
                    data.categoryListDropdown ? "rotate-180" : ""
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M19 9l-7 7-7-7" />
                </svg>
              </button>

              <button
                onClick={(e) =>
                  dispatch({
                    type: "searchDropdown",
                    payload: !data.searchDropdown,
                  })
                }
                className={`flex items-center gap-2 px-4 py-2.5 rounded-xl font-semibold text-sm transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-0.5 ${
                  data.searchDropdown
                    ? "bg-blue-600 text-white shadow-blue-300"
                    : "bg-white text-gray-700 hover:bg-blue-100 border border-blue-200"
                }`}
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
                <span>Rechercher</span>
              </button>
            </div>
          </div>

          {/* Contenu dropdown (catégories/recherche) */}
          <div className="px-4 pb-4 md:px-6 md:pb-6">
            <ProductCategoryDropdown />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ProductCategory;
